import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { logError } from 'services/logging/logging';
import { ConnectionsResponseDTO } from 'services/repositories/connections/connections';
import { Badge, BadgeColor } from 'components/Display/Badge/Badge';

type CatalogPartnerListLastRequestStatusProps = {
  status:
    | Required<ConnectionsResponseDTO['data'][number]>['sender_relationships'][number]['last_request_status']
    | null;
};
export const CatalogPartnerListLastRequestStatus: FC<CatalogPartnerListLastRequestStatusProps> = ({ status }) => {
  const { t } = useTranslation();
  switch (status) {
    case 'AWAITING_SUBMISSION':
      return <Badge color={BadgeColor.gray}>{t('priceCatalogs:lastRequestStatus.AWAITING_SUBMISSION')}</Badge>;
    case 'CATALOG_RECEIVED':
      return <Badge color={BadgeColor.blue}>{t('priceCatalogs:lastRequestStatus.CATALOG_RECEIVED')}</Badge>;
    case 'NO_RESPONSE':
      return <Badge color={BadgeColor.red}>{t('priceCatalogs:lastRequestStatus.NO_RESPONSE')}</Badge>;
    default:
      logError(`PriceCatalogList: Unknown last request status: ${status}.`);
      return null;
  }
};
